import CryptoJS from 'crypto-js';

//AES-- 密码 加密

// 密钥
const key = CryptoJS.enc.Utf8.parse('f062a5076b61492c');

// 初始化向量
const iv = CryptoJS.enc.Utf8.parse('943b2bd32f0432c7');

// 加密函数
export function encryptData(value) {

  const encrypted = CryptoJS.AES.encrypt(value, key, { iv, padding: CryptoJS.pad.Pkcs7 });

  return encrypted.toString();
}
